import React from 'react';
import { COLLECTION_LINES, countText } from './HomeCollectionLines';
import s from './HomeCollection.module.css';

// On a phone every tile is the same compact box (no links row), so the Collection tile says its counts in the
// description's place — "Sun 392 · Optic 77" (a narrow phone, ≤599px, leads with the season: "SS2027 · Sun 392 · Optic 77") — and the
// whole tile opens the Wall. Desktop shows the chips row instead.
export default function HomeCollectionCounts({ collection }) {
  return (
    <span className={s.counts} data-test="home-collection-counts">
      {collection?.season ? <span className={s.countsSeason}>{collection.season} · </span> : null}
      {COLLECTION_LINES.map(([key, label], i) => {
        const t = countText(collection?.lines?.[key]);
        return <React.Fragment key={key}>{i ? ' · ' : ''}{label}{t ? <> <b>{t}</b></> : null}</React.Fragment>;
      })}
    </span>
  );
}
